import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  title: '100 Science Warm-Ups & Bell-Ringers',
  description: 'Start every class in 5 minutes',
  price: '$19',
  image: 'https://cdn.magicpatterns.com/uploads/757CgQ3koCXZvoxbGLJ6QF/q1.webp'
}, {
  title: 'The Ultimate Physics & Chemistry Lab Pack',
  description: '30 hands-on experiments',
  price: '$27',
  image: 'https://cdn.magicpatterns.com/uploads/adkCCuzqiBVYQ6fiWmC5t3/q2.webp'
}, {
  title: 'Formula & Reference Sheets',
  description: 'Every key formula, ready to print',
  price: '$36',
  image: 'https://cdn.magicpatterns.com/uploads/imD1QYQ4QdCNhccTFXsot9/q3.webp'
}, {
  title: 'Science Vocabulary & Flashcards',
  description: '150+ terms made simple',
  price: '$19',
  image: 'https://cdn.magicpatterns.com/uploads/fzFRUY4gwgFa9Po8CyY4qN/q4.webp'
}, {
  title: 'Real-World STEM Projects Pack',
  description: '15 project-based activities',
  price: '$27',
  image: 'https://cdn.magicpatterns.com/uploads/22ByUQBpieSPv7GX7v4E9V/q5.webp'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="3tsffivcq9m16">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="2l2ycgbuh8l9">
        <div className="mb-12 text-center" data-id="element-19" data-mp="2kb0eyuryyrt">
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-20" data-mp="7kfl712pufnu">🎁 5 Exclusive Bonuses</h2>
          <p className="mt-4 text-brand-gray" data-id="element-21" data-mp="ck1z7cqdbzxp">Valued at <span className="font-bold text-brand-purple line-through" data-id="element-22" data-mp="cjaa8kra10ge">$147 USD</span> — Included <strong className="text-brand-teal" data-id="element-23" data-mp="gk2ltknmfhfu">FREE Today</strong></p>
        </div>
        <div className="space-y-3" data-id="element-24" data-mp="lbu12z1bu0qo">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-25" data-mp="qax82p0vah1a" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif font-bold text-white" data-id="element-26" data-mp="vc4fgmz3le7f">{index + 1}</span>
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-27" data-mp="akfqeqbmso9w" />
              <div className="min-w-0 flex-1" data-id="element-28" data-mp="kasa6gbmgdez">
                <h3 className="font-bold leading-snug text-brand-blue" data-id="element-29" data-mp="kclie01vv5p3">{bonus.title}</h3>
                <p className="mt-1 text-xs" data-id="element-30" data-mp="fjjzzi2gwo0r"><span className="text-brand-gray" data-id="element-31" data-mp="fi8u9cpgp670">{bonus.description}</span><span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-32" data-mp="tap3iv8yi0gd">was {bonus.price}</span><span className="ml-2 font-extrabold text-brand-teal" data-id="element-33" data-mp="odf6atfbskhz">FREE</span></p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}